
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grievance-form",
      function () {
        return require("private-next-pages/grievance-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grievance-form"])
      });
    }
  